"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ZLayers = void 0;
let ZLayers;
exports.ZLayers = ZLayers;

(function (ZLayers) {
  ZLayers[ZLayers["control"] = 50] = "control";
  ZLayers[ZLayers["footer"] = 90] = "footer";
  ZLayers[ZLayers["sidebar"] = 100] = "sidebar";
  ZLayers[ZLayers["sidebarControls"] = 105] = "sidebarControls";
  ZLayers[ZLayers["header"] = 110] = "header";
  ZLayers[ZLayers["uiElement"] = 200] = "uiElement";
  ZLayers[ZLayers["floating"] = 500] = "floating";
  ZLayers[ZLayers["modal"] = 800] = "modal";
  ZLayers[ZLayers["notification"] = 900] = "notification";
  ZLayers[ZLayers["tooltip"] = 1000] = "tooltip";
})(ZLayers || (exports.ZLayers = ZLayers = {}));

var _default = ZLayers;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJaTGF5ZXJzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RoZW1lL3pMYXllcnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gWkxheWVycyB7XG4gIGNvbnRyb2wgPSA1MCxcbiAgZm9vdGVyID0gOTAsXG4gIHNpZGViYXIgPSAxMDAsXG4gIHNpZGViYXJDb250cm9scyA9IDEwNSxcbiAgaGVhZGVyID0gMTEwLFxuICB1aUVsZW1lbnQgPSAyMDAsXG4gIGZsb2F0aW5nID0gNTAwLFxuICBtb2RhbCA9IDgwMCxcbiAgbm90aWZpY2F0aW9uID0gOTAwLFxuICB0b29sdGlwID0gMTAwMCxcbn1cblxuZXhwb3J0IGRlZmF1bHQgWkxheWVyc1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7SUFBWUEsTzs7O1dBQUFBLE87RUFBQUEsTyxDQUFBQSxPO0VBQUFBLE8sQ0FBQUEsTztFQUFBQSxPLENBQUFBLE87RUFBQUEsTyxDQUFBQSxPO0VBQUFBLE8sQ0FBQUEsTztFQUFBQSxPLENBQUFBLE87RUFBQUEsTyxDQUFBQSxPO0VBQUFBLE8sQ0FBQUEsTztFQUFBQSxPLENBQUFBLE87RUFBQUEsTyxDQUFBQSxPO0dBQUFBLE8sdUJBQUFBLE87O2VBYUdBLE8ifQ==